module.exports = __webpack_public_path__ + "static/media/bm.ca26b6f5.svg";